import { useCallback } from "react";
import type { DashboardBlockModelT, DashboardModelT } from "../../schema/dashboard";
import { useUpdateRemoteDashboardCallback } from "../api/dashboard";

export const useDashboardSaveCallback = () => {
  const updateDashboard = useUpdateRemoteDashboardCallback();
  return useCallback(
    ({
      toUpdateDashboard,
      toUpdateBlocks,
    }: {
      toUpdateDashboard: DashboardModelT;
      toUpdateBlocks: DashboardBlockModelT[];
    }) => updateDashboard(toUpdateDashboard, toUpdateBlocks),
    [updateDashboard],
  );
};
